/**
 * requireBaseUrl — FW-142 "sessiz varsayilan yok" kapisi.
 *
 * OLCULDU SORUN: bes yuzeyin bes main.ts'i de `apiClientOptions: { baseUrl: '/' }`
 * SABIT LITERAL veriyordu — derleme ortami (staging/production) ne olursa olsun
 * SPA hep KENDI originine istek atiyordu. Statik bir Cloudflare Pages sitesinde
 * (backend orada YOK, Pages Functions de mimari karariyla yasak) bu istekler
 * gercek backend'e hicbir zaman ulasmadan 404/405 ile basarisiz oluyordu —
 * bkz. FW-135 raporu "Kritik Bulgu" ve packages/api/src/index.ts basligindaki
 * FW-126 notu (relative baseUrl'in kendisi TypeError atiyordu, o AYRI bir hataydi;
 * bu ise adresin YANLIS/SESSIZ oldugu hatadir).
 *
 * KURAL: bir yuzeyin main.ts'i `import.meta.env.VITE_*_API_BASE_URL`'i HER ZAMAN
 * bu fonksiyondan gecirir — dev/staging/production farki gozetmeden. Deger
 * bos/tanimsizsa YUKSEK SESLE (Error firlatarak) durur; sessiz bir '/' ya da
 * bos string'e ASLA dusmez. Yerel gelistirme bu kuraldan MUAF DEGIL: gelistirici
 * kendi `.env.development` dosyasinda (bu depoda commit edilmis, bkz. her
 * yuzeyin kendi `.env.development`'i) gercek bir yerel backend adresi/vite proxy
 * yolu tanimlamak ZORUNDADIR — mock'a sessizce dusme YOK.
 *
 * Bu, hem "derleme aninda" hem "acilis aninda" yakalanir:
 *   - main.ts modulu tarayicida calistigi (acilis) an ilk satirlarda cagrilir,
 *     boylece herhangi bir API istegi atilmadan ONCE patlar.
 *   - `apps/*\/vite.config.ts` `command === 'build'` oldugunda AYNI degeri
 *     `loadEnv` ile okuyup erken dogrular (bkz. vite.config.ts) — CI, bir
 *     tarayici hic acmadan, `pnpm build` adiminda yakalar.
 */
export function requireBaseUrl(value: string | undefined, envVarName: string): string {
  if (typeof value === 'string' && value.trim().length > 0) {
    return value
  }

  throw new Error(
    `${envVarName} tanimli degil. Sessiz bir '/' varsayilanina DUSULMEZ (bkz. FW-142) — ` +
      `bu yuzeyin .env dosyasinda (yerel gelistirme icin .env.development, staging/production ` +
      `icin deploy-zamani ortam degiskeni) ${envVarName} mutlak bir URL olarak tanimlanmali.`,
  )
}
